import { SxProps, Theme } from '@mui/material';

export const modalBoxStyles: SxProps<Theme> = [
	{
		m: 2,
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			m: 1,
		},
	}),
];

export const containerFormStyles: SxProps<Theme> = [
	{
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		'& >div:first-child': {
			marginRight: 3,
		},
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
		},
	}),
];

export const autocompleteBoxStyles: SxProps<Theme> = [
	{
		'& .MuiFormHelperText-root': {
			position: 'absolute',
			margin: 0,
			bottom: '4px',
			fontSize: '12px',
			left: 0,
		},

		'.autocomplete': {
			'& .MuiInputBase-input .MuiOutlinedInput-root': {
				marginBottom: '24px',
			},
			'& .MuiOutlinedInput-root': {
				marginBottom: '24px',
			},

			'&.MuiFormLabel-root ': {
				marginBottom: '2px',
			},
			'&.MuiOutlinedInput-root .MuiSelect-icon': {
				top: '19px',
			},
		},
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			my: 0.5,
		},
	}),
];

export const inputBoxStyles: SxProps<Theme> = [
	{
		'& .MuiFormHelperText-root': {
			position: 'absolute',
			margin: 0,
			bottom: '4px',
			fontSize: '12px',
			left: 0,
		},
		'& .MuiInputBase-input .MuiOutlinedInput-root': {
			marginBottom: '24px',
		},
		'& .MuiOutlinedInput-root': {
			marginBottom: '24px',
		},
		'& .MuiOutlinedInput-root .MuiSelect-icon': {
			top: '19px',
		},
		'& .MuiOutlinedInput-root  .MuiOutlinedInput-input': {
			display: 'flex',
			alignItems: 'center',
		},
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			my: 0.5,
		},
	}),
];

export const containerButtonStyles: SxProps<Theme> = [
	{
		display: 'flex',
		alignItems: 'center',
		mt: 2,
		gap: 3,
		position: 'sticky',
		bottom: 0,
		zIndex: 1,
		backgroundColor: (theme) => theme.colors.white,
	},
];

export const errorTextStyles: SxProps<Theme> = [
	{
		fontWeight: 'bold',
		color: (theme) => theme.colors.red,
		pb: 2,
	},
];

export const buttonStyles: SxProps<Theme> = [
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			p: 0.5,
		},
	}),
];

export const leftButtonStyles: SxProps<Theme> = [
	{
		mr: 2,
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			mr: 1,
			p: 0.5,
		},
	}),
];
